import {
  valueFormat,
  valueFormatArpu,
  growthFormat,
} from '@/pages/intelligence/utils/commonUtils';
import { buildMetricCompareData } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/metricCompare';

// export const getEditionCountrytMetricKey = (pageId: string) => {
//   if (pageId === 'activeusers') {
//     return 'avg_dau';
//   }
//   if (pageId === 'revenue') {
//     return 'sum_revenue';
//   }
//   if (pageId === 'downloads') {
//     return 'sum_download';
//   }
// }

export const getMetricKey = (pageId: string) => {
  switch (pageId) {
    case 'activeusers':
      return 'dau';
    case 'revenue':
      return 'revenue';
    case 'downloads':
      return 'download';
    default:
      return 'dau';
  }
};

export const getPlatformName = (name: string) => {
  switch (name) {
    case 'ios':
      return 'App Store';
    case 'android':
      return 'Google Play';
    default:
      return '';
  }
};

export const getSegVal = (_mainSegment: string, _dateType: string) => {
  if ((_mainSegment === 'activeusers') && (_dateType === 'Month')) {
    return 'MAU';
  } else if ((_mainSegment === 'activeusers') && (_dateType === 'Week')) {
    return 'WAU';
  } else if (_mainSegment === 'activeusers') {
    return 'avg_dau';
    // return 'DAU';
  } else if (_mainSegment === 'revenue') {
    return 'Sum Revenue';
  } else if (_mainSegment === 'downloads') {
    return 'Downloads'
  }
  return 'DAU';
}

interface IActiveuserCompareConfig {
  entityType?: string;
  gameName?: string;
  gameCover?: string;
  dateType?: string;
  startDate?: string;
  endDate?: string;
}

const getActiveuserMetricCompareValueFormatter = (sortMetric: string) => {
  return (rawValue: string | number) => {
    const numValue = Number(rawValue);

    if (!Number.isFinite(numValue)) {
      return '-';
    }

    return sortMetric === 'arpu'
      ? valueFormatArpu(numValue, false, 0)
      : valueFormat(numValue);
  };
};

export const getActiveuserDetailMetricValueOfCvm = (
  cvm: any,
  sortMetric: string,
  compareConfig?: IActiveuserCompareConfig,
) => {
  const metrics = cvm?.metrics || [];
  const metric = metrics.find((item: any) => {
    return item?.metric === sortMetric;
  });
  const value =
    sortMetric === 'arpu'
      ? valueFormatArpu(metric?.value, false, 0)
      : valueFormat(metric?.value);
  const growthDataObj = growthFormat({
    value: metric?.growth_ratio,
    valueType: 'pointValue',
    hasPoint: 'lessThanOne',
    fixedNum: 2,
    maxNumber: 99999,
  });
  const dataCompareData = buildMetricCompareData({
    metric,
    granularity: compareConfig?.dateType,
    startDate: compareConfig?.startDate,
    endDate: compareConfig?.endDate,
    title: cvm?.name || compareConfig?.gameName,
    icon: cvm?.cover || compareConfig?.gameCover,
    entityType: compareConfig?.entityType || 'mobile',
    valueFormatter: getActiveuserMetricCompareValueFormatter(sortMetric),
  });

  return { value, growthDataObj, dataCompareData };
};
